import { createBrowserRouter } from "react-router-dom";
import Login from "../pages/Login";
import Apontamento from "../pages/Apontamento";
import ControleHoras from "../pages/ControleHoras";
import Perfil from "../pages/Perfil";
import ErrorPage from "../pages/errorPage";
import { AuthProviders } from "../providers/AuthContext/AuthContext";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/apontamento",
    element: <AuthProviders>
      <Apontamento />
    </AuthProviders>,
    errorElement: <ErrorPage />,
  },
  {
    path: "/controle_horas",
    element: <AuthProviders><ControleHoras /></AuthProviders>,
    errorElement: <ErrorPage />,
  },
  {
    path: "/perfil",
    element: <AuthProviders><Perfil /></AuthProviders>,
    errorElement: <ErrorPage />,
  },
]);
